<template>
    <h6>Blog Creado por Gerardo Maldonado Félix</h6>
    <h6>Rights Reserved © 2023</h6>
</template>
<script>
    export default{
        name: "BlogFooter",
    }
</script>
